var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4146 0.468816C20.7433 0.46902 21.0584 0.599662 21.2908 0.832044C21.5232 1.06443 21.6538 1.37955 21.654 1.70818L21.654 15.7388C21.6599 15.9052 21.6322 16.0711 21.5725 16.2266C21.5129 16.3821 21.4226 16.524 21.3069 16.6438C21.1912 16.7636 21.0526 16.8589 20.8993 16.924C20.746 16.9891 20.5812 17.0226 20.4146 17.0226C20.2481 17.0226 20.0833 16.9891 19.93 16.924C19.7767 16.8589 19.6381 16.7636 19.5224 16.6438C19.4067 16.524 19.3164 16.3821 19.2567 16.2266C19.1971 16.0711 19.1694 15.9052 19.1753 15.7388L19.1753 4.70137L2.58412 21.2925C2.35155 21.5251 2.03611 21.6558 1.7072 21.6558C1.3783 21.6558 1.06287 21.5251 0.830294 21.2925C0.597723 21.06 0.467066 20.7445 0.467065 20.4156C0.467067 20.0867 0.597724 19.7713 0.830295 19.5387L17.4215 2.94755L6.38407 2.94755C6.21763 2.95343 6.05171 2.92572 5.89622 2.86608C5.74072 2.80644 5.59883 2.71609 5.47901 2.60043C5.35919 2.48476 5.26389 2.34615 5.19881 2.19285C5.13372 2.03956 5.10018 1.87472 5.10018 1.70818C5.10018 1.54164 5.13372 1.37681 5.19881 1.22351C5.26389 1.07022 5.35919 0.931605 5.47901 0.815939C5.59883 0.700274 5.74072 0.609925 5.89622 0.550287C6.05171 0.490648 6.21763 0.46294 6.38406 0.468815L20.4146 0.468816Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowOut);
export default __webpack_public_path__ + "static/media/icon-arrow-out.ed41d727028fa652e64da807f87e96a9.svg";
export { ForwardRef as ReactComponent };